module.exports = __webpack_public_path__ + "img/nacional-gas-logo.3f7ab101.png";